import React from 'react';
import { FormattedMessage } from 'react-intl';
import EmptyState from '../../../../core/components/EmptyState';
import UnknownPost from '../../../../icons/UnknownPost';
import { PostContainer } from './styles';
const UnknownPostRenderer = () => {
    return (React.createElement(PostContainer, null,
        React.createElement(EmptyState, { title: React.createElement(FormattedMessage, { id: "post.unknownPost.title" }), icon: React.createElement(UnknownPost, null) },
            React.createElement(FormattedMessage, { id: "post.unknownPost.description" }))));
};
export default UnknownPostRenderer;
//# sourceMappingURL=UnknownPostRenderer.js.map